import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/performance_metrics_grid_data_actions';
import Tabs from './PerformanceMetricsTableTabs';
import { default as PerformanceMetricsTableGrid } from "./PerformanceMetricsTableGrid";

export class PerformanceMetricsTable extends Component {

  constructor(props) {
    super(props);

    this.state = {
      currentWorkDayTabSelected: false,
      previousWorkDaySelected: false,
      thirtyDayAverageSelected: false,
      noFilterOrTabSelected: true,
      currentTabSelected: 'Current Work Day',
      currentTabSelectedData: 'CurrentWorkDay',
      muSelectedItems: [],
      teamSelectedItems: [],
      agentSelectedItems: [],
      scorecardIds: [],
      displayTable: props.displayTable ? props.displayTable : false
    };

    this.TabFields = [
      { key: '0', label: "Current Work Day"},
      { key: '1', label: "Previous Work Day"},
      { key: '2', label: "30 Day Average"},      
    ]

    this.currentTabSelected = this.currentTabSelected.bind(this);
    this.getRequestParam = this.getRequestParam.bind(this);
    this.getCurrentDayRequestParam = this.getCurrentDayRequestParam.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { scorecardIds, muSelectedItems, teamSelectedItems, agentSelectedItems, actions} = this.props;
    if ( scorecardIds !== prevProps.scorecardIds && scorecardIds.length > 0) {
      //refresh previous day data

      if (Array.isArray(muSelectedItems)) {
        const prevMURequest = this.getRequestParam(muSelectedItems);
        actions.fetchPreviousWorkDayMUAction(prevMURequest);
      }
      if (Array.isArray(teamSelectedItems)) {
        const prevTeamRequest = this.getRequestParam(teamSelectedItems);
        actions.fetchPreviousWorkDayTeamAction(prevTeamRequest);
      }
      if (Array.isArray(agentSelectedItems)) {
        const prevAgentRequest = this.getRequestParam(agentSelectedItems);
        actions.fetchPreviousWorkDayAgentAction(prevAgentRequest);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { currentTabSelected, } = this.state;
    const { scorecardIds, muSelectedItems, teamSelectedItems, agentSelectedItems, displayTable, actions} = this.props;
    
    //set scorecard ids
    if(scorecardIds !== nextProps.scorecardIds) {
      this.setState({
        scorecardIds: nextProps.scorecardIds
      })
    }

    //get management unit data
    if(muSelectedItems !== nextProps.muSelectedItems) {
      this.setState({
        muSelectedItems: nextProps.muSelectedItems
      })

      const requestParam = this.getRequestParam(nextProps.muSelectedItems);
      actions.fetchPreviousWorkDayMUAction(requestParam);

      if(currentTabSelected === "30 Day Average") {
        actions.fetchThirtyDayAverageMUAction(requestParam);
      }
      else if(currentTabSelected === "Current Work Day") {
        const cRequestParam = this.getCurrentDayRequestParam(nextProps.muSelectedItems, 'mu');
        actions.fetchCurrentWorkDayMUAction(cRequestParam);
      }
    }

    //get team data
    if(teamSelectedItems !== nextProps.teamSelectedItems) {
      this.setState({
        teamSelectedItems: nextProps.teamSelectedItems
      })
      const requestParam = this.getRequestParam(nextProps.teamSelectedItems);

      actions.fetchPreviousWorkDayTeamAction(requestParam);

      if(currentTabSelected === "30 Day Average") {
        actions.fetchThirtyDayAverageTeamAction(requestParam);
      }
      else if(currentTabSelected === "Current Work Day") {
        const cRequestParam = this.getCurrentDayRequestParam(nextProps.teamSelectedItems, 'team');
        actions.fetchCurrentWorkDayTeamAction(cRequestParam);
      }
    }

    //get agent data
    if(agentSelectedItems !== nextProps.agentSelectedItems) {
      this.setState({
        agentSelectedItems: nextProps.agentSelectedItems
      })
      
      const requestParam = this.getRequestParam(nextProps.agentSelectedItems);

      actions.fetchPreviousWorkDayAgentAction(requestParam);

      if(currentTabSelected === "30 Day Average") {
        actions.fetchThirtyDayAverageAgentAction(requestParam);
      }
      else if(currentTabSelected === "Current Work Day") {
        const cRequestParam = this.getCurrentDayRequestParam(nextProps.agentSelectedItems, 'agent');
        actions.fetchCurrentWorkDayAgentAction(cRequestParam);
      }
    }

    if(displayTable !== nextProps.displayTable) {
      this.setState({
        displayTable: nextProps.displayTable
      })
    }
  }
  
  currentTabSelected(e) {
    const { agentSelectedItems, teamSelectedItems, muSelectedItems } = this.state;
    const { 
      fetchCurrentWorkDayAgentAction, fetchCurrentWorkDayTeamAction, fetchCurrentWorkDayMUAction,
      fetchPreviousWorkDayAgentAction, fetchPreviousWorkDayTeamAction, fetchPreviousWorkDayMUAction,
      fetchThirtyDayAverageAgentAction, fetchThirtyDayAverageTeamAction, fetchThirtyDayAverageMUAction,
    } = this.props.actions;

    let currentTabSelectedData = '';

    if(e === 'Current Work Day') {  
      //must pull previous day data if it doesn't exist for day over day calculation
      if(agentSelectedItems && agentSelectedItems.length > 0) {
        const prevAgentRequestParam = this.getRequestParam(agentSelectedItems);
        fetchPreviousWorkDayAgentAction(prevAgentRequestParam);

        const agentRequestParam = this.getCurrentDayRequestParam(agentSelectedItems, 'agent');
        fetchCurrentWorkDayAgentAction(agentRequestParam);
      }
      if(teamSelectedItems && teamSelectedItems.length > 0) {
        const prevTeamRequestParam = this.getRequestParam(teamSelectedItems);
        fetchPreviousWorkDayTeamAction(prevTeamRequestParam);
        
        const teamRequestParam = this.getCurrentDayRequestParam(teamSelectedItems, 'team');
        fetchCurrentWorkDayTeamAction(teamRequestParam);
      }
      if(muSelectedItems && muSelectedItems.length > 0) {
        const prevMURequestPraram = this.getRequestParam(muSelectedItems);
        fetchPreviousWorkDayMUAction(prevMURequestPraram);

        const muRequestParam = this.getCurrentDayRequestParam(muSelectedItems, 'mu');
        fetchCurrentWorkDayMUAction(muRequestParam);
      }
      currentTabSelectedData = 'CurrentWorkDay';
    } else if(e === 'Previous Work Day') {
      if(agentSelectedItems && agentSelectedItems.length > 0) {
        const requestParam = this.getRequestParam(agentSelectedItems);
        fetchPreviousWorkDayAgentAction(requestParam);
      }
      if(teamSelectedItems && teamSelectedItems.length > 0) {
        const requestParam = this.getRequestParam(teamSelectedItems);
        fetchPreviousWorkDayTeamAction(requestParam);
      }
      if(muSelectedItems && muSelectedItems.length > 0) {
        const requestParam = this.getRequestParam(muSelectedItems);
        fetchPreviousWorkDayMUAction(requestParam);
      }
      currentTabSelectedData = 'PreviousWorkDay';
    } else if(e === '30 Day Average') {
      if(agentSelectedItems && agentSelectedItems.length > 0) {
        const requestParam = this.getRequestParam(agentSelectedItems);
        fetchThirtyDayAverageAgentAction(requestParam);
      }
      if(teamSelectedItems && teamSelectedItems.length > 0) {
        const requestParam = this.getRequestParam(teamSelectedItems);
        fetchThirtyDayAverageTeamAction(requestParam);
      }
      if(muSelectedItems && muSelectedItems.length > 0) {
        const requestParam = this.getRequestParam(muSelectedItems);
        fetchThirtyDayAverageMUAction(requestParam);
      }
      currentTabSelectedData = 'ThirtyDayAverage';
    }
    this.setState({ currentTabSelected: e, currentTabSelectedData: currentTabSelectedData });
  }

  //previous and thirty day request parameter
  getRequestParam(itemsSelected) {
    let cardIds = [];
    cardIds.push(0); //set default;

    if(this.state && this.state.scorecardIds) {
      cardIds = []; //reset
      cardIds = this.state.scorecardIds.join(",");
    }
    
    //get formatted selected Ids
    var ids = itemsSelected.map(obj => { 
      var rObj = [];
      rObj.push(obj.key);
      return rObj;
    });

    let idString = ids.join(",");

    //construct request parameter
    let requestParam = {
      ids: idString,
      cardIds: cardIds
    }
    return requestParam;
  }

  //current day request parameter
  getCurrentDayRequestParam(appliedItems, type) {
    let groupingType = 0;
    switch(type) {
      case 'mu':
        groupingType = 1;
      break;
      case 'team':
        groupingType = 2;
      break;
      case 'agent':
        groupingType = 3;
      break;
      // no default
    }

    let idResultString = "";
    if(appliedItems && Object.keys(appliedItems).length > 0) {

      idResultString = "&" + Object.keys(appliedItems).map(item => {
        let id = appliedItems[item].key;
        return `ids=${parseInt(id, 10)}`;
        }).join('&');
    }

    let requestParam = {
      customQueryParams: idResultString,
      groupingType: groupingType
    }
    
    return requestParam;
  }

  render() {
    let { currentTabSelected, currentTabSelectedData } = this.state;
    let { isTablet } = this.props;
    
    return (
      <div className="table">
        { isTablet ? 
          <div className="table__title">
            Performance Metrics
          </div> 
        : '' }
        <Tabs currentTabSelected={this.currentTabSelected} activeTab={currentTabSelected}>
          {this.TabFields.map((tabField) => (
            <div key={ tabField.key } label={ tabField.label }>
              <PerformanceMetricsTableGrid currentTabSelectedData={currentTabSelectedData} viewScorecard={ this.props.viewScorecard }/>
            </div>
          ))}
        </Tabs>
        
        { !this.state.displayTable ? 
          <div className="table__placeholder">
            <div className="table__placeholder-graph">graph</div>
            <div className="table__placeholder-text">
              Apply filters to display scorecard data
            </div>
          </div>  
        : null }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isTablet: state.common.isTablet,
    displayTable: state.scorecard.displayTable,
    muSelectedItems: state.scorecard.muSelectedItems,
    teamSelectedItems: state.scorecard.teamSelectedItems,
    agentSelectedItems: state.scorecard.agentSelectedItems,
    scorecardIds: state.scorecard.scorecardIds
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformanceMetricsTable);



// WEBPACK FOOTER //
// ./src/features/scorecard/PerformanceMetricsTable.js